import React from "react";
var __jsx = React.createElement;
import { useIntl } from 'react-intl';
import { SuperScriptStyleToggle } from 'components/common/RichTextEditor/tools/InlineToolbar/InlineToolbar.style';
import { StyleType } from 'components/common/RichTextEditor/util/style';
import { SuperScript } from 'theme/icons';

var SuperScriptTab = function SuperScriptTab(_ref) {
  var editorState = _ref.editorState,
      handleInlineStyleToggle = _ref.handleInlineStyleToggle;
  var intl = useIntl();
  var label = intl.formatMessage({
    id: 'content.labels.inline-toolbar.superscript'
  });
  return __jsx(SuperScriptStyleToggle, {
    onMouseDown: handleInlineStyleToggle(StyleType.SUPERSCRIPT),
    toggled: editorState.getCurrentInlineStyle().contains(StyleType.SUPERSCRIPT),
    title: label,
    "aria-label": label
  }, __jsx(SuperScript, null));
};

export default SuperScriptTab;